import { render, staticRenderFns } from "./BasicInfoChild.vue?vue&type=template&id=3e5327cb&scoped=true&"
import script from "./BasicInfoChild.vue?vue&type=script&lang=js&"
export * from "./BasicInfoChild.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoChild.vue?vue&type=style&index=0&id=3e5327cb&lang=scss&scoped=true&"
import style1 from "./BasicInfoChild.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5327cb",
  null
  
)

export default component.exports